export const COURSE_BUILDER_STEPS = [
  "overview",
  "curriculum",
  "resources",
  "pricing",
  "cohorts",
  "announcements",
  "publish",
] as const;

export type CourseBuilderStep = (typeof COURSE_BUILDER_STEPS)[number];

const HASH_TO_STEP: Record<string, CourseBuilderStep> = {
  overview: "overview",
  curriculum: "curriculum",
  resources: "resources",
  pricing: "pricing",
  cohorts: "cohorts",
  "cohort-live": "cohorts",
  announcements: "announcements",
  publish: "publish",
};

export function isCourseBuilderStep(value: string): value is CourseBuilderStep {
  return (COURSE_BUILDER_STEPS as readonly string[]).includes(value);
}

/** Map URL hash (without #) to a builder step; default curriculum. */
export function resolveBuilderStepFromHash(hash: string | null | undefined): CourseBuilderStep {
  const key = (hash ?? "").replace(/^#/, "").trim().toLowerCase();
  if (!key) return "curriculum";
  return HASH_TO_STEP[key] ?? "curriculum";
}

export function builderStepHash(step: CourseBuilderStep): string {
  return `#${step}`;
}
